<template>
  <div>
    Bitte warten...
  </div>
</template>

<script>
export default {
  beforeMount() {
    if (this.$route.query.aff || this.$route.query.discount) {
      const now = new Date();
      const time = now.getTime();
      const expireTime = time + 1000 * 60 * 60 * 24 * 365;

      now.setTime(expireTime);

      if (this.$route.query.aff) {
        const { aff } = this.$route.query;
        const cookie = `${escape('aff')}=${escape(aff)};expires=${now.toGMTString()}`;
        document.cookie = cookie;
        localStorage.setItem('aff', aff);
      }

      if (this.$route.query.discount) {
        const discount = true;
        const cookie = `${escape('discount')
        }=${
          escape(discount)
        };expires=${
          now.toGMTString()}`;
        document.cookie = cookie;
        localStorage.setItem('discount', discount);
      }
    }
  },

  created() {
    document.body.classList.add('main-background');
    window.location.href = 'https://www.chance4talents.de/wer-bist-du';
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/index.scss";
.top {
  position: absolute;
  left: -10vw;
  max-height: 15vh;
  width: 120vw;
  top: 0;
}
.register {
  min-height: 100vh;
  padding: 15px;
  padding-top: 100px;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
}
.v-btn {
  margin-left: 0;
}
h2 {
  color: grey;
  font-weight: 400;
  font-size: 16px;
}
h5 {
  color: grey;
  font-weight: 400;
  font-size: 14px;
}
.stepper {
  width: 100vw;
  min-height: 100vh;
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 89vh;
}

.datepicker {
  margin-bottom: 20px;
}

.player-kind {
  cursor: pointer;
  display: grid;
  grid-template-columns: 20% 70% 10%;
  width: 400px;
  max-width: 90vw;
  border-radius: 10px;
  padding: 15px;
  img {
    width: 70%;
    max-width: 40px;
  }
  margin-top: 15px;
  p {
    margin-bottom: 0;
  }
  div {
    align-self: center;
  }
}
.back-to-login {
  z-index: 6;
  position: absolute;
  color: green;
  left: 10px;
  top: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  text-decoration: none;
}

.btn {
  color: white;
  background: rgb(23,161,60);
  padding: 5px;
  border-radius: 5px;
}

.badge {
  font-size: 11px;
  color: rgb(70, 70, 70);
  background: rgb(231, 231, 231);
  border: 1px solid rgb(86, 224, 86);
  padding: 0 4px;
  border-radius: 8px;
  position: absolute;
  right:5px;
  top:6px;
}
</style>
